import { render, staticRenderFns } from "./authorizedinvitationsub.vue?vue&type=template&id=dfb2bb8c&scoped=true"
import script from "./authorizedinvitationsub.vue?vue&type=script&lang=js"
export * from "./authorizedinvitationsub.vue?vue&type=script&lang=js"
import style0 from "./authorizedinvitationsub.vue?vue&type=style&index=0&id=dfb2bb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb2bb8c",
  null
  
)

export default component.exports